import React, { useEffect, useRef, useState } from 'react'
import parse from 'html-react-parser'
import cx from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faXmark } from '@fortawesome/free-solid-svg-icons'
import { Button } from '~elements'
import { ButtonProps, RichTextType } from '~types'
import styles from './NotificationBanner.module.scss'

interface NotificationBannerProps {
  copy: RichTextType
  bannerText: RichTextType
  expandedModuleTitle: RichTextType
  ctaPrimary?: ButtonProps
  showBanner: boolean
}

const NotificationBanner = ({
  copy,
  ctaPrimary,
  showBanner,
  bannerText,
  expandedModuleTitle
}: NotificationBannerProps) => {
  const ref = useRef(null)
  const [height, setHeight] = useState(0)

  const [showOverlay, setShowOverlay] = useState(false)

  useEffect(() => {
    const el = ref.current

    if (!el) return

    const updateHeight = () => {
      const measuredHeight = el.offsetHeight
      setHeight(measuredHeight)
    }

    updateHeight()

    const observer = new ResizeObserver(() => {
      updateHeight()
    })

    observer.observe(el)

    return () => observer.disconnect()
  }, [])

  const caret = () => {
    setShowOverlay(true)
  }

  if (showBanner) {
    return (
      <>
        <div ref={ref} className={styles['notification-banner']} id='notification-banner'>
          <div className={styles.container}>
            <div className={styles['notification_banner__content']}>
              <div className={styles['notification_banner__text']}>
                {bannerText?.html && parse(bannerText.html)}
                <span className={styles['caret']} onClick={() => caret()}>
                  <FontAwesomeIcon size='lg' icon={faAngleDown} />
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className={cx([styles['overlay-bar'], styles[showOverlay ? 'is-open' : '']])}>
          <div className={styles.closeBtn}>
            <FontAwesomeIcon icon={faXmark} onClick={() => setShowOverlay(false)} />
          </div>
          <div className={styles['overlay-content']}>
            <div className={styles['overlay-content__wrapper']}>
              <div className={styles['overlay-content__copy-container']}>
                {expandedModuleTitle?.html && (
                  <div className={styles['overlay-title']}> {parse(expandedModuleTitle.html)}</div>
                )}
                {copy?.html && <div className={styles['overlay-copy']}>{parse(copy.html)}</div>}
                {ctaPrimary && (
                  <div className={styles['notification_banner__button']}>
                    <Button
                      {...ctaPrimary}
                      analytics={{
                        linkModule: 'notification_banner',
                        linkLocation: 'header'
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {showOverlay && <div className={styles.overlay} onClick={() => setShowOverlay(false)}></div>}
        {/* Spacer to push down page content to prevent overlapping. */}
        <div style={{ height: height }} />
      </>
    )
  } else {
    return <div className={styles['notification-banner']} id='notification-banner' />
  }
}
export default NotificationBanner
